/* eslint-disable no-extra-boolean-cast */
import React, { useState } from 'react';
import shortid from 'shortid';
import { OptionGroup as TdsOptionGroup, FormItem } from '@tesla/react-tds/global';
// eslint-disable-next-line import/no-cycle
import Option from './Option';
import useFormField from '../../hooks/useFormField';

const OptionGroupContext = React.createContext();

const OptionGroup = ({
  children,
  required,
  label,
  options,
  alternate,
  multiselect,
  className,
  noFormItem,
  ...props
}) => {
  const [id] = useState(shortid.generate());

  const { defaultHandler, formFieldContext, render, userProps, formFieldRef } = useFormField({
    ...props,
    multiselect,
    required,
    type: multiselect ? 'array' : props.type,
  });

  const { disabled } = userProps;

  let ariaRequired = !!required;
  let ariaRole = 'radiogroup';

  if (multiselect) {
    ariaRequired = undefined;
    ariaRole = 'group';
  }

  const context = {
    optionGroupHandler: {
      ...formFieldContext.defaultHandler,
    },
    optionGroupContext: {
      name: userProps.name,
      multiselect,
      ...formFieldContext,
      id,
      disabled: userProps.disabled,
    },
  };

  if (noFormItem) {
    return (
      <OptionGroupContext.Provider value={context}>
        <div
          className={`
                tds-option_group
                ${!!alternate ? 'tds-option_group--alternate' : ''}
                ${!!multiselect ? 'tds-option_group--multiselect' : ''}
                ${className}
            `}
          role={ariaRole}
          aria-required={ariaRequired}
          aria-labelledby={defaultHandler.id}
        >
          {options
            ? options.map((option) => <Option key={`${id}-${option.value}`} {...option} />)
            : children}
        </div>
      </OptionGroupContext.Provider>
    );
  }
  return (
    <OptionGroupContext.Provider value={context}>
      <FormItem
        error={formFieldContext.$showError}
        errorLabel={formFieldContext.error}
        id={defaultHandler.id}
        label={label}
      >
        <div
          className={`
              tds-option_group
              ${!!alternate ? 'tds-option_group--alternate' : ''}
              ${!!multiselect ? 'tds-option_group--multiselect' : ''}
              ${className}
          `}
          role={ariaRole}
          aria-required={ariaRequired}
          aria-labelledby={defaultHandler.id}
        >
          {options
            ? options.map((option) => <Option key={`${id}-${option.value}`} {...option} />)
            : children}
        </div>
      </FormItem>
    </OptionGroupContext.Provider>
  );
};

export { OptionGroupContext };

export default OptionGroup;
